// Load all the controllers within this directory and all subdirectories. 
// Controller files must be named *_controller.js.

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

// Handle modal dismiss event by clearing the modal frame
document.addEventListener('turbo:before-cache', () => {
  const modal = document.getElementById('modal');
  if (modal) {
    modal.innerHTML = '';
  }
});

// Handle modal close button clicks
document.addEventListener('click', (e) => {
  if (e.target.matches('[data-dismiss="modal"]')) {
    const modal = document.getElementById('modal');
    if (modal) {
      modal.innerHTML = '';
    }
  }
});

const application = Application.start()
const context = require.context("controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(context))
